import { resource } from '@/plugins/http'

export default resource('/v1/settings/me/settings')



// WEBPACK FOOTER //
// ./src/store/resources/settings.js